export const INDIVIDUAL_RECORD_TYPE = "individual";
export const GAME_RECORD_SPAN = "game";
export const TOURNAMENT_RECORD_SPAN = "tournament";
export const CAREER_RECORD_SPAN = "career";
export const DEFAULT_TITLE = "Quizbowl Stats";
